import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { useState, useEffect, useMemo } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
} from "@mui/material";
import "./style.css";
import { Icon } from "@iconify/react";
import { UserListHead, UserListToolbar } from "../sections/@dashboard/user";
import WithAuth from "../components/WithAuth";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import TicketsDetailsPopUp from "../components/TicketsDetailsPopUp";
import Popup from "../components/Popup";
import Menu from "@mui/material/Menu";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { bgStyles } from "../utils/cssStyles";

const TABLE_HEAD = [
  { id: "key", label: "Ticket Id", alignRight: false },
  { id: "summary", label: "Ticket Summary", alignRight: false },
  { id: "status", label: "Ticket Status", alignRight: false },
  { id: "" },
];

function descendingComparator(a, b, orderBy) {
  const getNumericPart = (str) => {
    if (typeof str === 'string') {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }
    return 0;
  };

  if (getNumericPart(b[orderBy]) < getNumericPart(a[orderBy])) {
    return -1;
  }
  if (getNumericPart(b[orderBy]) > getNumericPart(a[orderBy])) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => -descendingComparator(a, b, orderBy)
    : (a, b) => descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  if (!Array.isArray(array)) {
    return [];
  }

  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(array, (_user) =>
      Object.values(_user).some((value) =>
        String(value).toLowerCase().includes(query.toLowerCase())
      )
    );
  }

  return stabilizedThis.map((el) => el[0]);
}

function CheckStatus() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("key");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loder, setLoder] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState("");
  const [closeOpenApi, setCloseOpenApi] = useState("");
  const [response, setResponse] = useState("");
  const [flag, setFlag] = useState(false);
  const [apiPostData, setApiPostData] = useState("");
  const [ticketId, setTicketId] = useState("");
  const [ticketStatus, setTicketStatus] = useState("");
  const [filterData, setFilterData] = useState("To Do");
  const [api, setApi] = useState("/todotickets");
  const theme = useTheme();
  const isBelow768 = useMediaQuery(theme.breakpoints.down("sm"));

  const [sessionResponse, setSessionResponse] = useState("");
  const [sessionFlag, setSessionFlag] = useState(false);

  const [timeoutFlag, setTimeoutFlag] = useState(false);

  const textColorGreen = {
    color: "white",
    backgroundColor: "#31933a",
    textAlign: "center",
    padding: "5px",
    borderRadius: "4px",
    width: isBelow768 ? "75px" : "120px",
  };
  const textColorRed = {
    color: "white",
    textAlign: "center",
    padding: "5px",
    borderRadius: "4px",
    backgroundColor: "#CB3809",
    width: isBelow768 ? "75px" : "120px",
  };
  const textColorBlue = {
    color: "white",
    textAlign: "center",
    padding: "5px",
    borderRadius: "4px",
    backgroundColor: "#64A7F3",
    width: isBelow768 ? "75px" : "120px",
  };
  const textColorYellow = {
    color: "white",
    textAlign: "center",
    padding: "5px",
    borderRadius: "4px",
    backgroundColor: "#F1BC43",
    width: isBelow768 ? "75px" : "120px",
  };

  useMemo(() => {
    setApi(`/meonsupport/get_list/${filterData}`);
  }, [filterData]);

  const handleChange = (event) => {
    setFilterData(event.target.value);
  };

  useEffect(() => {
    setLoder(true);
    axios.get(api, {
      headers: {
        'Cache-Control': 'no-store',
      },
      params: {
        page: page + 1,
        rows_per_page: rowsPerPage,
      },
      timeout: 20000
    }).then((response) => {
      setLoder(false);
      if (response.data === "Logged out") {
        setSessionResponse("Session expired. Please login again.");
        setSessionFlag(true);
        sessionStorage.removeItem("token");
      } else {
        setAllData(response.data.tickets || []);
        setTotalRows(response.data.total || 0);
      }
    })
      .catch((error) => {
        if (error.code === "ECONNABORTED") {
          setTimeoutFlag(true);
        }
      })
      .finally(() => {
        setLoder(false);
      });
  }, [api, closeOpenApi, apiPostData, page, rowsPerPage]);

  const handleTickets = (key, status) => {
    setTicketId(key);
    setTicketStatus(status);
  };

  const handleCloseTicketDetails = () => {
    setIsOpen(false);
  };

  const handleClose = () => {
    setApiPostData({
      ticket: "",
      status: "",
    });
    setFlag(false);
    setTicketId("");
    setTicketStatus("");
  };

  const handleSessionClose = () => {
    setSessionFlag(false);
    navigate("/login");
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = 0;

  const filteredUsers = applySortFilter(
    allData,
    getComparator(order, orderBy),
    filterName
  );

  const isNotFound = !filteredUsers.length && !!filterName;
  const navigate = useNavigate();
  const handleCreateTicketButton = () => {
    navigate("/reportissue");
  };

  const handleTicketDetails = (id) => {
    setIsOpen(true);
    setId(id);
  };

  const handleReOpenTicket = (key, status) => {
    setCloseOpenApi("/meonsupport/reopentickets");
    setApiPostData({
      ticket: key,
      status: status,
    });
    setAnchorEl(null);
  };

  const handleCloseTicket = (key, status) => {
    setCloseOpenApi("/meonsupport/closeticket");
    setApiPostData({
      ticket: key,
      status: status,
    });
    setAnchorEl(null);
  };

  useEffect(() => {
    setLoder(true);
    if (apiPostData.ticket) {
      axios.post(closeOpenApi, apiPostData).then((response) => {
        setResponse(response.data);
        setFlag(true);
        setLoder(false);
      });
    }
  }, [closeOpenApi, apiPostData]);

  const handleTimeoutClose = () => {
    setTimeoutFlag(false);
    window.location.reload();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const meopen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseme = () => {
    setAnchorEl(null);
  };

  const { ticketId: ticketQuery } = useParams();

  useEffect(() => {
    if (ticketQuery) {
      setTicketId(ticketQuery);
      setIsOpen(true);
    }
  }, [ticketQuery]);

  return (
    <Wrapper>
      <Helmet>
        <title> Check Status | Support Tool </title>
      </Helmet>
      {loder ? (
        <div style={bgStyles}></div>
      ) : (
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
            mx={1}
          >
            <Typography
              variant="h4"
              sx={{ marginTop: "4px", color: "#103996" }}
            >
              Check Status
            </Typography>
            <Button
              onClick={handleCreateTicketButton}
              variant="contained"
              startIcon={<Icon icon="eva:plus-fill" />}
              sx={{ boxShadow: "none", fontWeight: 400 }}
            >
              Create Ticket
            </Button>
          </Stack>

          <Card style={{ border: "1px solid #c7c7c7", boxShadow: "none" }}>
            <UserListToolbar
              filterName={filterName}
              onFilterName={handleFilterByName}
              handleChange={handleChange}
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <Box sx={{ overflow: "auto" }}>
              <TableContainer
                sx={{ width: "100%", padding: isBelow768 ? 0 : "" }}
              >
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={allData.length}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {filteredUsers && filteredUsers?.length > 0 && filteredUsers

                      ?.map((row, index) => {
                        const { crm_id, status, summary } = row;
                        return (
                          <TableRow
                            key={crm_id}
                            tabIndex={-1}
                            status="checkbox"
                            className="tableRow"
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                              onClick={() => handleTicketDetails(crm_id)}
                              sx={{ cursor: "pointer" }}
                            >
                              <Typography
                                variant="subtitle2"
                                style={{ marginLeft: "20px" }}
                              >
                                {crm_id}
                              </Typography>
                            </TableCell>

                            <TableCell
                              onClick={() => handleTicketDetails(crm_id)}
                              align="left"
                              sx={{ cursor: "pointer", width: "50%" }}
                            >
                              {isBelow768
                                ? summary.split(" ").slice(0, 4).join(" ") +
                                " ..."
                                : summary}
                            </TableCell>

                            <TableCell
                              onClick={() => handleTicketDetails(crm_id)}
                              align="left"
                              sx={{ cursor: "pointer" }}
                            >
                              <p
                                style={
                                  status === "Done"
                                    ? textColorGreen
                                    : status === "On Hold" || status === "To Do"
                                      ? textColorRed
                                      : status === "In Progress" || status === "Testing"
                                        ? textColorYellow
                                        : textColorBlue
                                }
                              >
                                {status}
                              </p>
                            </TableCell>

                            <TableCell
                              onClick={() => {
                                handleTickets(crm_id, status);
                              }}
                              align="right"
                            >
                              <IconButton
                                size="large"
                                color="inherit"
                                id="demo-positioned-button"
                                aria-controls={
                                  meopen ? "demo-positioned-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={meopen ? "true" : undefined}
                                onClick={handleClick}
                                sx={{ cursor: "pointer" }}
                              >
                                <Icon icon={"eva:more-vertical-fill"} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorEl}
                      open={meopen}
                      onClose={handleCloseme}
                      anchorOrigin={{
                        vertical: "center",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "center",
                        horizontal: "right",
                      }}
                    >
                      <MenuItem
                        onClick={() =>
                          handleReOpenTicket(ticketId, ticketStatus)
                        }
                        disabled={
                          ticketStatus === "Done" ||
                            ticketStatus === "DELIVERED"
                            ? false
                            : true
                        }
                        style={{ color: "green" }}
                      >
                        <Icon
                          icon="codicon:issue-reopened"
                          style={{ marginRight: "5px" }}
                          color="green"
                          width="24"
                          height="24"
                        />
                        ReOpen Ticket
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleCloseTicket(ticketId, ticketStatus)
                        }
                        style={{ color: "red" }}
                        disabled={ticketStatus === "Done" ? true : false}
                      >
                        <Icon
                          icon="ic:round-close"
                          style={{ marginRight: "5px" }}
                          color="red"
                          width="24"
                          height="24"
                        />
                        Close Ticket
                      </MenuItem>
                    </Menu>
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete
                              words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Box>

            <TablePagination
              rowsPerPageOptions={[10, 20, 30]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      )}
      <TicketsDetailsPopUp
        id={id}
        flag={isOpen}
        handleClose={handleCloseTicketDetails}
        setLoder={setLoder}
        Loder={loder}
      />
      <Popup response={response} flag={flag} handleClose={handleClose} />
      <Popup response={sessionResponse} flag={sessionFlag} handleClose={handleSessionClose} />
      <Popup response="Request timed out. Please refresh the page." flag={timeoutFlag} handleClose={handleTimeoutClose} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 15px;
  @media only screen and (max-width: 768px) {
    .css-1oqqzyl-MuiContainer-root {
      padding-left: 0;
      padding-right: 0;
    }
  }

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  /* Thumb */
  ::-webkit-scrollbar-thumb {
    background-color: red;
    border-radius: 4px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background-color: darkred;
  }

  /* Disable auto-hiding behavior */
  scrollbar-width: auto; /* Firefox */
  -ms-overflow-style: auto; /* IE and Edge */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
`;

export default WithAuth(CheckStatus);
